module.exports = __webpack_public_path__ + "sounds/0-100-sprite-675ff9af49838afaf6fe04732b3442b1.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/sound/0-100/0-100-sprite.ogg
// module id = 14
// module chunks = 0